import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Modules } from 'src/app/providers/core-role-access-service';
import { CoreHelperService } from '../../../providers/core-helper/core-helper.service';
import { DepartmentId } from 'src/app/common/enum/department';
import { LocalStorageService } from 'src/app/common/service/storage.service';
import { UserDomainType } from 'src/app/common/enum/user-domain';
import { environment } from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  sidebarToggle = false;
  sidebarToggleMobile = false;
  isFacilityUser: boolean = false;
  userId: number;
  facilityId: number;
  title: string = '';
  userInfo: any;
  activeModuleName: string = "";
  versionText: string = "";
  siteEnvironment: string = "";
  userDomain: number = 0;

  userPermissionMenu: any = [];
  sectionsList: any = [];
  sectionModule: any = [];
  mvpModuleList: any = [];

  userDepartmentId: number = 0;
  showCehreusLogo: boolean = false;
  isVobUser: boolean = false;

  constructor(
    private router: Router,
    public _coreHelper: CoreHelperService,
    private _storageService: LocalStorageService) {
    this.userDepartmentId = this._coreHelper.getOpsDepartmentId();
    this.isVobUser = (this.userDepartmentId == DepartmentId.Vob);
  }

  ngOnInit(): void {
    this.siteEnvironment = `${environment.env_name.toString().toUpperCase()}`;
    this.versionText = this._coreHelper.getAppVersion();
    this.userDomain = this._coreHelper.getUserDomain();
    this.isFacilityUser = (this.userDomain === 1);
    this.userInfo = this._coreHelper.getLoggedInUserDetail()
    this.userId = this._coreHelper.getUserId();
    this.facilityId = this._coreHelper.getFacilityId();

    //Loading Dynamic Menus
    if (localStorage.getItem("cereus-cache") != undefined || localStorage.getItem("cereus-cache") != undefined) {
      let userPermissionValue = JSON.parse(this._storageService.getItem("cereus-cache"));
      if (userPermissionValue != null && userPermissionValue != undefined) {
        let userMenus = Array.from(new Map(userPermissionValue.map(mnu => [mnu.moduleMasterId, mnu])).values())
        this.userPermissionMenu = userMenus;

        if (this.userPermissionMenu != "[]" && this.userPermissionMenu.length > 0) {
          let menusList = this.userPermissionMenu;
          const sectionName = 'Dashboards';
          const section = menusList.find(
            item => item.sectionName === sectionName
          );
          this.sectionsList = section ? [section] : [];

          this.sectionModule = [
            ...new Map(menusList.map((mnu) => [mnu["moduleName"], mnu])).values(),
          ];

          this.mvpModuleList = this.sectionModule.filter(
            section =>
              section.sectionName !== sectionName &&
              section.navigationRoute != null
          );
        }
      }
    }
    this._coreHelper.sidebarActiveModuleName.subscribe((moduleName: string) => {
      this.activeModuleName = moduleName;
    });
  }

  public get moduleName(): typeof Modules {
    return Modules;
  }

  isMultipleFaility = () => {
    return this.userInfo.isMultipleFacility;
  }

  setTitle(title: string, isDashboard: boolean = false) {
    localStorage.setItem('title', title)
    this.title = title;
    if (isDashboard) {
      this._coreHelper.setSidebarModuleName("");
      $('#sidebarAccordion .collapse').collapse('hide');
    }
    this.checkRouteForLogoSetup(title);
  }

  redirect() {
    let deptId = this._coreHelper.getOpsDepartmentId();
    if (deptId === DepartmentId.Vob) {
      this.router.navigate(['/auth/vob-dashboard']);

    } else if (deptId === DepartmentId.Authorization) {
      this.router.navigate(['/auth/auth-dashboard']);

    } else if (this._coreHelper.getLoggedInUserDomain() === UserDomainType.External) {
      this.router.navigate(['/auth/report/cereus-overview'])

    } else if (this._coreHelper.getLoggedInUserDetail()?.roleName == 'Executive') {
      this.router.navigate(['/auth/executive-dashboard'])

    } else if ((this._coreHelper.getLoggedInUserDomain() === 0) && !(this._coreHelper.getLoggedInUserDetail()?.roleName == 'Executive')) {
      this.router.navigate(['/auth/dashboard']);
    }
  }

  redirectURL(url: string) {
    if (this.isFacilityUser && url === 'auth/services/document')
      this.router.navigate(['/auth/facility-dashboard']);
    else
      this.router.navigate([url]);
  }

  addBodyClass() {
    var test = document.getElementsByTagName('body')
    this.sidebarToggle = !this.sidebarToggle;

    if (!!this.sidebarToggle) {
      test[0].classList.add('nav-toggle')
    } else {
      test[0].classList.remove('nav-toggle')
    }
  }

  addBodyClassMobile() {
    var test1 = document.getElementsByTagName('body')
    this.sidebarToggleMobile = !this.sidebarToggleMobile;

    if (!!this.sidebarToggleMobile) {
      test1[0].classList.add('nav-toggle-mobile')
    } else {
      test1[0].classList.remove('nav-toggle-mobile')
    }
  }

  getRouterLinkForTab(sectionName, moduleName, tabName) {
    if (sectionName == "Resource") {
      if (moduleName == "Facility Master") {
        return "auth/resource/facility/facility-master";
      }
    }
    return ""
  }

  // This method checks the route and sets the logo based on the title
  checkRouteForLogoSetup(paramTitle: string = '') {
    this.showCehreusLogo = false;
    if (paramTitle.includes('Facility Master') || paramTitle.includes('Carrier Master') || paramTitle.includes('Patient Master')) {
      this.showCehreusLogo = true;
    }
  }
}
